<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Historical Tracking Routes</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-accordion-group>
        <ion-accordion value="first">
            <ion-item slot="header" color="secondary">
                <ion-label color="light">Legend</ion-label>
            </ion-item>
            <div class="ion-padding" slot="content">
                <span class="line1">Viewing Trip: {{currentTripIdx + 1}} of {{getNumTrips()}}</span><br />
                <span class="line2">Date: {{getTripDate(currentTrip)}}</span><br />
                <span class="line2">Time: {{getStartTime(currentTrip)}} - {{getEndTime(currentTrip)}}</span><br />
                <span class="line2">Duration: {{getDuration(currentTrip)}}</span><br />
                <span class="line2">Type: {{getTripType(currentTrip)}}</span><br />
                <span class="line2">Driver: {{getDriver(currentTrip)}}</span><br />
            </div>
        </ion-accordion>
    </ion-accordion-group>

    <!-- <ion-list-header color="secondary" class="ion-padding" style="height: 130px;">
        <ion-label class="ion-padding">
            <span class="line1">Viewing Trip: {{this.currentTripIdx + 1}}</span><br /> 
        </ion-label>
    </ion-list-header>
 -->
    <button data-test="centerDealership" class="centerDealership" ion-button (click)="onCenterDealershipClick()">
        <img src="../../assets/images/dealershipMarker.png" title="Center the dealership" />
    </button>

    <button data-test="previousTrip" class="previousTrip" ion-button (click)="onPreviousTripClick()">
        <img src="../../assets/images/previous.png" title="Previous Trip" />
    </button>

    <button data-test="nextTrip" class="nextTrip" ion-button (click)="onNextTripClick()">
        <img src="../../assets/images/next.png" title="Next Trip" />
    </button>

    <app-google-map
        [dealershipCoordinate]="dealershipCoordinate"
        [initialZoom]="14"
        [mapId]="'SHUTTLE_HISTORICAL_ROUTES_MAP'"
        [showCenterButton]="false"
        (mapReady)="onMapReady()"
        (mapError)="onMapError($event)">
    </app-google-map>
</ion-content>
